import type { BackendRouteDefinition } from '../types';

export const findEmployeeTenantRoute = {
  transport: 'api',
  method: 'POST',
  path: '/public/employee-tenants:lookup',
  body: ({ email }: { email: string }) => ({ email }),
} as const satisfies BackendRouteDefinition;
